module.exports = __webpack_public_path__ + "media/images/whitecloacktechnologies-bbf825265e2f1d856eb0141a15003fbb.png";